import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropBookingsByEmail } from '~/navigation/Navigation.types';

import { BookingItem } from '../BookingItem';
import { BookingList, BookingListNative } from '../Bookings.List';

export const BookingsByEmailScreen = (props: ScreenPropBookingsByEmail) => {
  return (
    <PageContainer>
      <BookingsLayout {...props} />
    </PageContainer>
  );
};

export const BookingsLayout = (props: ScreenPropBookingsByEmail) => {
  const bookingId = props.route.params?.id;
  const email = props.route.params?.email;

  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(bookingId);
  }, [bookingId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <BookingList onPress={(item) => setId(item.id)} email={email} />
      ) : (
        <BookingListNative email={email} />
      )}
      {id ? <BookingItem bookingId={id} onClose={() => setId(undefined)} /> : <></>}
    </ScreenTwoPageLayout>
  );
};
